/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { helpTextId, idVariation } from 'volta/utils/id';

import { guidFor } from '@ember/object/internals';
import { isBlank } from '@ember/utils';
import Component from '@glimmer/component';
import type { ComponentLike } from '@glint/template';

import type { BvFormLayoutItemSignature } from '../item';
import type { BvStackSignature } from 'volta/components/bv-stack';

export interface BvFormLayoutGroupSignature {
  Args: {
    text?: string;
    condensed?: boolean;
    title?: string;
    helpText?: string;
    id?: string;
  };
  Blocks: {
    default: [{ Item: ComponentLike<BvFormLayoutItemSignature> }];
  };
  Element: BvStackSignature['Element'];
}

export default class BvFormLayoutGroupComponent extends Component<BvFormLayoutGroupSignature> {
  'data-test-form-layout-group' = true;

  get id() {
    return this.args.id ?? guidFor(this);
  }

  get titleId() {
    if (isBlank(this.args.title)) {
      return;
    }
    return idVariation(this.id, 'Title');
  }

  get helpTextId() {
    if (isBlank(this.args.helpText)) {
      return;
    }

    return helpTextId(this.id);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvFormLayout::Group': typeof BvFormLayoutGroupComponent;
    'bv-form-layout/group': typeof BvFormLayoutGroupComponent;
  }
}
